<template>
    <div class="pagination" :style="{
        justifyContent: position
    }">
        <el-pagination @size-change="handleSizeChange" :current-page="currentPage" @current-change="handleCurrentChange"
            :page-sizes="pageSizes" :page-size="definePage.pageSize" layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
    </div>
</template>
<script>
import { definePage } from './config';
export default {
    props: {
        total: {
            type: Number,
            default: 0
        },
        position: {
            type: String,
            default: 'end'
        },
        currentPage: {
            type: Number,
            default: 1
        },
    },
    data() {
        return {
            pageSizes: [10, 20, 50, 100],
            definePage: {}
        }
    },
    methods: {
        handleSizeChange(val) {
            this.definePage.pageSize = val
            this.$emit('change', this.definePage)

        },
        handleCurrentChange(val) {
            this.definePage.pageNow = val
            this.$emit('change', this.definePage)
        }
    },
    mounted() {
        this.definePage = structuredClone(definePage)
    }
}
</script>
<style lang='scss' scoped>
.pagination {
    display: flex;
}
</style>


// WEBPACK FOOTER //
// src/components/easyPagination/index.vue